import styled from "@emotion/styled";
import PropTypes from "prop-types";

import styles from "./DrawerFooter.style";

const DrawerFooterStyled = styled.section((props) => ({ ...styles(props) }));

const DrawerFooter = ({ children, disabled, className, hasSmallSpacing, ...rest }) => {
    if (disabled || !children) {
        return null;
    }

    return (
        <DrawerFooterStyled className={className} hasSmallSpacing={hasSmallSpacing} {...rest}>
            <div className="drawerFooter_inner">{children}</div>
        </DrawerFooterStyled>
    );
};

DrawerFooter.propTypes = {
    disabled: PropTypes.bool,
    className: PropTypes.string,
    hasSmallSpacing: PropTypes.bool,
};

DrawerFooter.defaultProps = {
    disabled: false,
    className: undefined,
    hasSmallSpacing: false,
};

export default DrawerFooter;
